import { useNavigate } from "react-router-dom";
import { useSafeApiCall, useApiClient } from "src/hooks/api";

export const useDeleteApplicationInvite = () => {
  const safeApiCall = useSafeApiCall();
  const { fetchFromApi } = useApiClient();
  const navigate = useNavigate();

  return (
    dealer_id: string,
    application_id: string,
    application_status: string,
    setIsLoading: React.Dispatch<React.SetStateAction<boolean>>,
  ) => {
    const path = `/dealer-portal/v1/${dealer_id}/applications/invite/${application_id}`;

    setIsLoading(true);

    void safeApiCall(() => fetchFromApi(path, { method: "DELETE" }), {
      toastSuccessMsg: "Application invite deleted successfully.",
      toastErrorMsg: `Error deleting application. Status: ${application_status}`,
    }).then(() => {
      void navigate(`/${dealer_id}/applications`, { replace: true });
    });

    setIsLoading(false);
  };
};
